import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialModule } from '../../material/material.module';
import { JobsService } from '../../services/jobs.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-checkout-status',
  imports: [CommonModule, MaterialModule],
  templateUrl: './checkout-status.component.html',
  styleUrl: './checkout-status.component.scss'
})
export class CheckoutStatusComponent {
  private readonly _apiService = inject(JobsService);
  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute)
  private readonly _snackbar = inject(MatSnackBar)

  status = input();
  data: any = signal(null);

  constructor() {
    effect(() => {
      if (this.status()) {
        let session_id: any;
        this._route.queryParams.subscribe((param: any) => {
          session_id = param.session_id;
        }) || '';
        this._apiService.getTransactionDetails(session_id).subscribe({
          next: (res: any) => {
            this.data.set(res.data)
          },
          error: (err: any) => {
            this._snackbar.open(err?.error?.message || "Unable to fetch transsaction details")
          }
        })
      }
    })
  }

  // Get current date and time formatted
  getCurrentDateTime(): string {
    return new Date().toLocaleString('en-AE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Dubai'
    });
  }

  // Success page actions
  goToDashboard(): void {
    this._router.navigate(['/dashboard']);
  }

  downloadReceipt(): void {
    // Implement receipt download logic
    console.log('Downloading receipt...');

    // Create a simple receipt blob
    const receiptData = {
      transactionId: 'TXN123456789',
      amount: '2,500 AED',
      credits: '250 Credits',
      date: this.getCurrentDateTime(),
      status: 'Success'
    };

    const blob = new Blob([JSON.stringify(receiptData, null, 2)],
      { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `receipt-${Date.now()}.json`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  contactSupport(): void {
    // Navigate to support or open support modal
    window.open('mailto:support@example.com?subject=Payment Issue&body=Transaction failed with error code: PAYMENT_DECLINED_001', '_blank');
  }

  retryPayment() {
    window.location.href = this.data().session?.url;
  }

  calculateCredits(total_amount: any) {
    return (total_amount / 100) / 10;
  }
}